module.exports = __webpack_public_path__ + "static/media/car.0c56e2a0.svg";